import keymirror from 'keymirror';

export default keymirror({
  MAIN: null,
  ICU: null,
});
